var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGreenCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9 0C4.032 0 0 4.032 0 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9ZM7.907 12.793a1 1 0 0 1-1.414 0L3.335 9.635a.898.898 0 0 1 1.269-1.27L7.2 10.952l6.192-6.192a.9.9 0 1 1 1.274 1.274l-6.759 6.758Z",
  fill: "#0FD246"
})));
export default SvgGreenCheck;